import React, { Component } from 'react';
import config from '../../config';
import { formatUrlForCdn, updateSrcSetForCdn } from '../../utils/url';

class Img extends Component {
    constructor(props) {
        super(props);
        this.setImgRef = this.setImgRef.bind(this);
        this.image = React.createRef();
    }

    setImgRef(img) {
        this.image = img;
        const { onImgLoad } = this.props;
        if (this.image && onImgLoad) {
            this.image.addEventListener('load', onImgLoad(this.image));
            if (this.image.complete) {
                onImgLoad(this.image);
            }
        }
    }

    render() {
        const { cdnUrl } = config;
        const { onImgLoad, useRawSrcSet, defaultimg, noCdn, ...rest } = this.props;
        const { srcSet, src } = this.props;
        const useCdn = cdnUrl && !noCdn;
        let cdnSrcSet;
        let cdnSrc;
        if (useCdn) {
            if (srcSet) {
                cdnSrcSet = useRawSrcSet ? srcSet : updateSrcSetForCdn(srcSet);
            }
            cdnSrc = formatUrlForCdn(src);
        }
        // if (propsForImg.onImgLoad) delete propsForImg.prototype.onImgLoad;

        // delete propsForImg.defaultimg;
        return (useCdn
            ? (
                <img
                    {...rest}
                    src={cdnSrc || ''}
                    srcSet={cdnSrcSet || ''}
                    ref={el => this.setImgRef(el)}
                    onError={(e) => {
                        if (defaultimg) {
                            e.target.src = `${defaultimg}`;
                            e.target.srcset = `${defaultimg}`;
                        }
                    }}
                />
            )
            : (
                <img
                    {...rest}
                    ref={el => this.setImgRef(el)}
                    onError={(e) => {
                        if (defaultimg) {
                            e.target.src = `${defaultimg}`;
                            e.target.srcset = `${defaultimg}`;
                        }
                    }}
                />
            )
        );
    }
}

export default Img;
